import request from '@/utils/request'
import { GetCutOffOverseasWarehousesRes, GetCutOffWarehousesRes } from './types'

/** 컷오프 대상 센터 목록 조회 */
export const getCutOffWarehouses = () => request.post<ApiResponseV2<GetCutOffWarehousesRes>, undefined>('/api/v1/get-cutoff-warehouses', undefined)

/** 해외출고 관리 센터 목록 조회 */
export const getCutOffOverseasWarehouses = () =>
  request.post<ApiResponseV2<GetCutOffOverseasWarehousesRes>, undefined>('/api/v1/get-cutoff-overseas-warehouses', undefined)
